module.exports = __webpack_public_path__ + "img/logo4.009d1790.png";